import { mixed, object } from 'yup'

const employeeImportSchema = object().shape({
  File: mixed().required(),
})

export default employeeImportSchema
